import { render, staticRenderFns } from "./orgAddAccount.vue?vue&type=template&id=1ccad2ce&scoped=true&"
import script from "./orgAddAccount.js?vue&type=script&lang=js&"
export * from "./orgAddAccount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccad2ce",
  null
  
)

export default component.exports